var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleBanners.length > 0
    ? _c(
        "div",
        { staticClass: "reward-banner-container" },
        _vm._l(_vm.visibleBanners, function (banner) {
          return _c(
            "div",
            {
              key: "reward_banner_" + banner.promotionId,
              staticClass:
                "reward-banner d-flex align-items-center p-2 mb-2 rounded",
            },
            [
              _c("b-icon", {
                staticClass: "text-success mr-2 flex-shrink-0",
                attrs: { icon: "gift-fill", "font-scale": "1.5" },
              }),
              _c("div", { staticClass: "flex-grow-1" }, [
                _c("p", { staticClass: "mb-0 font-weight-bold" }, [
                  _vm._v(" " + _vm._s(banner.title) + " "),
                ]),
                _c("p", { staticClass: "mb-0 small text-muted" }, [
                  _vm._v(" " + _vm._s(banner.subtitle) + " "),
                ]),
              ]),
              banner.description
                ? [
                    _c(
                      "button",
                      {
                        staticClass:
                          "reward-banner-info-btn flex-shrink-0 ml-2",
                        attrs: {
                          id: "reward_banner_info_" + banner.promotionId,
                          type: "button",
                          "aria-label": _vm.$t("Detalhes da promoção"),
                        },
                      },
                      [
                        _c("b-icon", {
                          staticClass: "text-success",
                          attrs: { icon: "info-circle", "font-scale": "1.5" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-popover",
                      {
                        attrs: {
                          target: "reward_banner_info_" + banner.promotionId,
                          triggers: "click blur",
                          placement: "left",
                          title: banner.name || _vm.$t("Promoção"),
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "reward-banner-description" },
                          [_vm._v(" " + _vm._s(banner.description) + " ")]
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }